<div class="page-loader">
  <div class="loader"></div>
  <div class="loading_text">
    <span>Loading...</span>
  </div>
</div>